module.exports = __webpack_public_path__ + "media/images/athletes/2030-7e6d3b93b9d7cae4aecaafe7a244e459.png";